module.exports = __webpack_public_path__ + "static/banner-shoe-2a553c2b62781273925de3a7c4e2f8c5.png";